module.exports = __webpack_public_path__ + "static/media/SingleCoupon_title.fc672df5.png";